import React from "react"
import { OpenModalButton } from "../../common/components/openModalButton"
import CaldaiaForm from "./caldaiaForm";
import Actions from "../caldaieActions";
import { CaldaiaDto, CaldaiaDataDto } from "../../generated";
import { CaldaieStore } from "../caldaieStore";
import { Loading } from "../../common/components/loading";

interface Props { idCaldaia?: number; onSelect: (idCaldaia: CaldaiaDto | null) => void }

const ModalContent = (props: { idCaldaia?: number, onClose: (caldaia: CaldaiaDto | null) => void }) => {

    const { onClose } = props;

    const caldaia = props.idCaldaia ? CaldaieStore.use(props.idCaldaia) : new CaldaiaDto();
    if (!caldaia)
        return <Loading />

    const save = async (caldaia: CaldaiaDataDto) => {
        if (props.idCaldaia) {
            const result = await Actions.update(props.idCaldaia, caldaia);
            onClose(result);
        }
        else {
            const result = await Actions.add(caldaia);
            onClose(result);
        }
    }

    return (
        <CaldaiaForm
            caldaia={caldaia}
            onSubmit={save}
            onCancel={() => onClose(null)}
        />
    );
}

export const CaldaiaToolbarButton = (props: Props) => {
    const modal = React.useRef<OpenModalButton>(null);
    return <div className="row">
        <div className="col-6">
            <OpenModalButton
                ref={modal}
                forceReload
                className="btn btn-outline-secondary w-100"
                modalContent={<ModalContent
                    onClose={id => {
                        modal.current!.close();
                        if (id != null)
                            props.onSelect(id);
                    }}
                />}
            >
                <i className="fas fa-plus" />  Modello
            </OpenModalButton>
        </div>
        {props.idCaldaia != null &&
            <div className="col-6">
                <OpenModalButton
                    ref={modal}
                    forceReload
                    className="btn btn-outline-secondary w-100"
                    modalContent={<ModalContent
                        idCaldaia={props.idCaldaia}
                        onClose={id => {
                            modal.current!.close();
                            if (id != null)
                                props.onSelect(id);
                        }}
                    />}
                >
                    <i className="fas fa-edit" /> Modifica
                </OpenModalButton>
            </div>
        }
    </div>
}
